import axios from 'axios';
import { API_BASE } from '../lib/config';

// --- Types ---
export interface RegisterPayload { email: string; password: string; name?: string; }
export interface LoginPayload { email: string; password: string; }
export interface AuthResponse { user: { id: string; email: string; name?: string }; access_token: string; }
export interface ProfileResponse { user: { id: string; email: string; name?: string; profile_image?: string } }
export interface Template { id: string; name: string; }
export interface TemplatesListResponse { templates: Template[]; }
export interface DownloadResponse { url: string; }
export interface StripeCheckoutPayload { amount: number; tierName: string; }
export interface StripeCheckoutResponse { checkoutUrl: string; sessionId: string; }
export interface StripeVerifyPayload { sessionId: string; }
export interface StripeVerifyResponse { status: string; payment_id: string; }
export interface PaymentHistoryResponse { payments: any[]; }
export interface UserDownloadsResponse { downloads: any[]; }
export interface DashboardResponse { dashboard: { message: string; user: any } }

// --- Axios instance ---
export const api = axios.create({ baseURL: API_BASE });

// Add a global response interceptor for error logging
api.interceptors.response.use(
  response => response,
  error => {
    console.error(error.response?.status, error.config?.url);
    return Promise.reject(error);
  }
);

// --- Auth ---
export const registerUser = (payload: RegisterPayload) => api.post<AuthResponse>('auth/register', payload).then(r => r.data);
export const loginUser = (payload: LoginPayload) => api.post<AuthResponse>('auth/login', payload).then(r => r.data);
export const getProfile = () => api.get<ProfileResponse>('auth/profile').then(r => r.data);

// --- Templates ---
export const listTemplates = () => api.get<TemplatesListResponse>('templates').then(r => r.data);
export const downloadTemplate = (templateId: string) => api.get<DownloadResponse>(`templates/download?id=${encodeURIComponent(templateId)}`).then(r => r.data);

// --- Payments ---
export const createStripeCheckout = (payload: StripeCheckoutPayload) => api.post<StripeCheckoutResponse>('payment/stripe/create-checkout', payload).then(r => r.data);
export const verifyStripePayment = (payload: StripeVerifyPayload) => api.post<StripeVerifyResponse>('payment/stripe/verify', payload).then(r => r.data);
export const getPaymentHistory = () => api.get<PaymentHistoryResponse>('payment/history').then(r => r.data);

// --- User ---
export const getUserDownloads = () => api.get<UserDownloadsResponse>('user/downloads').then(r => r.data);
export const getDashboard = () => api.get<DashboardResponse>('dashboard').then(r => r.data); 